import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, CardContent, Typography, MenuItem, Table, TableBody, TableRow, TableCell, TableHead, Icon, IconButton } from '@material-ui/core';

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    intro: {
        color: '#ffffff'
    },
    card: {
        width: '100%',
        maxWidth: 400
    }
});

class AuthInstructorTab extends Component {

    constructor(props) {
        super(props);
    }

    getCourseTable = (courses, instructor_id) => {

        const currentCourseRows = courses.map(c => {
            return (
                <TableRow key={c.company_calendar_course_id}>
                    <TableCell>{c.CourseName}</TableCell>
                    <TableCell>
                        <IconButton
                            onClick={() => this.props.history.push('/gradebook/' + c.company_calendar_course_id)}
                        >
                            <Icon>book</Icon>
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })

        const tableBase =
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Course</TableCell>
                        <TableCell>To Gradebook</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentCourseRows}
                </TableBody>
            </Table>
        return tableBase
    }

    render() {
        const { classes, currentAuth } = this.props;
        // const {  } = this.state;
        const instructor = currentAuth.roles.filter(r => r.RoleName === 'Instructor')[0];

        const currentCourses = instructor.link_info.ActiveCourses;

        return (
            <div>
                {currentCourses.length === 0 ?
                    <Typography variant="h5"> No Courses </Typography>
                    :
                    <React.Fragment>
                        <Typography variant="h5"> Courses </Typography>
                        {this.getCourseTable(currentCourses, instructor.link_id)}
                    </React.Fragment>
                }

            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        auth
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthInstructorTab)));


// WEBPACK FOOTER //
// src/main/content/auth/AuthInstructorTab.js